<template>
  <div class="wrap">
    <header>
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{lang.set}}</h2>
    </header>
    <div class="main">
      <div class="setting-wrap">
        <p class="setting-list" @click="changeNav('ChangePass','login')">
          <span>{{lang.resetloginpass}}</span>
          <span class="iconfont icon-back-right"></span>
        </p>
        <p class="setting-list" @click="changeNav('ChangePass','trade')">
          <span>{{lang.resetqkinpass}}</span>
          <span class="iconfont icon-back-right"></span>
        </p>
        <p class="btn" @click="logout">{{lang.logout}}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex';
  import {
    APP_INFO
  } from '@/assets/js/config'
  export default {
    data() {
      return {
        isAPP: APP_INFO.APP,
        APPver: APP_INFO.VERSION,
        langue: ''
      }
    },
    mounted() {
      if (window.plus) {
        let _this = this
        plus.runtime.getProperty(plus.runtime.appid, inf => {
          _this.APPver = inf.version
        })
      }
    },
    computed: {
      ...mapState(['lang', 'langTypes'])
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      changeNav(url,type) {
        if(type){
          this.$router.push({
            name:url,
            query:{
              type:type
            }
          })
        }else{
          this.$router.push(url)
        }
      },
      logout(){
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/user/logout')
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.$router.push('Login');
              this.$store.dispatch('clear_userInfo');
              window.localStorage.clear();
            }else if (res.data.err == 200||res.data.err == 201){
              this.$router.push({
                name:'Maintenance',
                query:{
                  num:res.data.err
                }
              })
            }else{
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$router.push('/');
          })
      }
    },
  }
</script>
<style type="text/css" scoped>

  .setting-wrap {
    padding: 20px;
  }

  .setting-list {
    height: 50px;
    display: flex;
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    align-items: center;
  }

  .setting-list .icon-front {
    color: rgba(4, 15, 66, 0.3);
  }

  .setting-wrap .btn {
    margin: 30px 10px 0;
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    border-radius: 20px;
    font-size: 16px;
    background: #3476FE;
  }

  .blue {
    background: #f8513e !important;
  }

  .yellow {
    background: #ffb115 !important;
  }

  .green {
    background: #73ae4e !important;
  }

  .red {
    background: #f39e24 !important;
  }
</style>